import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import CheckboxGroup from '../../../exportacion_react_pdf/CheckboxGroup';
import QuestionResponse from '../../../exportacion_react_pdf/QuestionResponse';
import TextAreaLabel from '../../../exportacion_react_pdf/TextAreaLabel';
import SelectGroup from '../../../exportacion_react_pdf/SelectGroup';
import TablaCalificacion from '../../../exportacion_react_pdf/TablaCalificacion';
import TextAreaLabelGroup from '../../../exportacion_react_pdf/TextAreaLabelGroup';

const secciones_enfoque_genero = [
  {
    key: '1',
    title: 'ENFOQUES DE GÉNERO Y DIFERENCIALES ',
    questions: [
        {
            section: '1.1',
            description: 'El/la productor/a identifica 1 o más temáticas específicas de género en las que ha sido formado/a, relevantes para su iniciativa productiva, Ej: Equidad en la participación y toma de decisiones, roles de liderazgo femenino, distribución equitativa de tareas y carga de trabajo laboral y de cuidado, prevención de la violencia basada en género, masculinidades corresponsables y no violentas.',
        },
        {
            section: '1.2',
            description: 'El/la productor/a refiere 1 o más estrategias implementadas en su unidad productiva, que posibilitan la igualdad de acceso a recursos y oportunidades para hombres, mujeres y población diferencial, Ej: Distribución equitativa de tareas, participación de las mujeres en organos de desición, adapatación de equipos e instalaciones a población adulta mayor y/o en condición de discapacidad, espacios de formación específicos para mujeres y sus intereses y necesidades formativas, espacios diseñados para la conciliación de las actividades productivas y de cuidado como salas de lactancia, etc...',
        }

    ],
}
  ];

// Define el documento
const ExportPaso5 = ({ formData, styles  }) => {
    return (
    <>
    {/* Sección de Identificació del proyecto */}
    <View style={styles.section}>

        <Text style={styles.title_1}>ENFOQUE DE GÉNERO</Text>


        <CheckboxGroup
            label='¿Ha recibido capacitación específica sobre igualdad de género?'
            selectedValue={formData?.capacitacion_igualdad_genero || ''}>
        </CheckboxGroup>

        <CheckboxGroup
            label='¿Ha implementado prácticas que favorezcan la equidad de género en su unidad productiva?'
            selectedValue={formData?.implementado_practicas_equidad_genero || ''}>
        </CheckboxGroup>

       
        <TextAreaLabelGroup
            label='¿Quién es responsable de las actividades de cuidado en su hogar?'
            selectedValue={formData?.responsable_acitividades_cuidado_hogar || ''}>
        </TextAreaLabelGroup>

        <QuestionResponse
            label='¿Considera que esta carga de trabajo afecta su participación en su unidad de negocio?'
            value={formData?.carga_trabajo_afecta_productividad || ''}>
        </QuestionResponse>

        <Text style={styles.title_1}>CAPACIDADES DE ENFOQUE-TRANSVERSAL</Text>

        <TablaCalificacion evaluacion={formData?.capacidades_enfoque_transversal} secciones={secciones_enfoque_genero}></TablaCalificacion>
        {/* Título principal */}
        <Text style={styles.tag}>
            SEGUNDA PARTE. PROPUESTA PLAN DE ACOMPAÑAMIENTO INTEGRAL BASADO EN MEJORAMIENTO DE INDICADORES
        </Text>

        {/* Título secundario */}
        <Text style={styles.greyTag}>
            SELECCIÓN DE INDICADORES
        </Text>

        {/* Nota para el equipo */}
        <Text style={styles.noteTitle}>
            NOTA PARA EL EQUIPO
        </Text>
        <Text style={styles.noteText}>
            En este punto se deben identificar los aspectos que es posible mejorar en el predio, considerando la realidad del productor,
            condiciones de la finca, recursos, tiempo, etc. Se sugiere seleccionar un máximo de 6 indicadores a mejorar. Los indicadores
            deben seleccionarse de manera conjunta con el productor, quien recibirá acompañamiento y responderá por los procesos y las
            recomendaciones dadas para su cumplimiento.
        </Text>



        <TextAreaLabelGroup
            label='Nombre del indicador'
            selectedValue={formData?.capacidades_enfoque_transversal?.seleccion_indicador?.nombre_indicador || ''}>
        </TextAreaLabelGroup>


          {/* Título secundario */}
          <Text style={styles.greyTag}>
          SECCIÓN PLAN DE ACOMPAÑAMIENTO INTEGRAL - MÓDULOS FORTALECIMIENTO

        </Text>


        <Text style={styles.noteText}>
        Temas de interes del productor, y requeridos para el mejoramiento de los indicadores seleccionados. Se
        recomienda priorizar y elegir unicamente los asociados a cumplimiento de indicadores.
        </Text>
        

        <TextAreaLabelGroup
            label='Participación y Liderazgo Femenino en la Economía Productiva'
            selectedValue={formData?.capacidades_enfoque_transversal?.acompanamiento_integral?.participacion_liderazgo_femenino || ''}>
        </TextAreaLabelGroup>

        <TextAreaLabelGroup
            label='Gestión integral del cuidado'
            selectedValue={formData?.capacidades_enfoque_transversal?.acompanamiento_integral?.gestion_integral_cuidado || ''}>
        </TextAreaLabelGroup>

        <TextAreaLabelGroup
            label='Masculinidades co responsables y no violentas'
            selectedValue={formData?.capacidades_enfoque_transversal?.acompanamiento_integral?.masculinidades_co_responsables_no_violentas || ''}>
        </TextAreaLabelGroup>

        <TextAreaLabelGroup
            label='Violencias Basadas en Género'
            selectedValue={formData?.capacidades_enfoque_transversal?.acompanamiento_integral?.violencias_basadas_en_genero || ''}>
        </TextAreaLabelGroup>

        <TextAreaLabelGroup
            label='Derechos sexuales y Derechos Reproductivos - DSDR'
            selectedValue={formData?.capacidades_enfoque_transversal?.acompanamiento_integral?.derechos_sexuales_y_derechos_reproductivos || ''}>
        </TextAreaLabelGroup>

    </View>
</>
    )

};

export default ExportPaso5;